module.exports = __webpack_public_path__ + "static/media/WZ6.b540ceda.jpg";